/**
 * Entities API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import {
  createEntity,
  disableEntity,
  enableEntity,
  getEntities,
  getEntityById,
  patchEntity,
} from "../generated/entities/entities";

import { wrapListMethod, wrapMethod } from "./utils";

export const entities = {
  /** @see createEntity */
  create: wrapMethod(createEntity),

  /** @see getEntities */
  list: wrapListMethod(getEntities),

  /** @see getEntityById */
  get: wrapMethod(getEntityById),

  /** @see patchEntity */
  update: wrapMethod(patchEntity),

  /** @see enableEntity */
  enableEntity: wrapMethod(enableEntity),

  /** @see disableEntity */
  disableEntity: wrapMethod(disableEntity),
} as const;

export type EntitiesApi = typeof entities;
